import { InjectionToken, inject } from '@angular/core';
import { DocumentReference, DocumentSnapshot, Firestore, getFirestore, onSnapshot } from 'firebase/firestore';
import { Observable } from 'rxjs';
import { FIREBASE_APP } from '../core/firebase.providers';
import { FIREBASE_AUTH } from './firebase.auth';

export const FIREBASE_FIRESTORE = new InjectionToken<Firestore>('Firebase Firestore', {
  providedIn: 'root',
  factory: () => {
    // Auth initializes App Check first; keep both ready before creating Firestore.
    inject(FIREBASE_AUTH);
    return getFirestore(inject(FIREBASE_APP));
  },
});

export function observeDocumentSnapshots(ref: DocumentReference): Observable<DocumentSnapshot> {
  return new Observable(subscriber => onSnapshot(ref, { includeMetadataChanges: true }, {
    next: snapshot => subscriber.next(snapshot),
    error: error => subscriber.error(error),
    complete: () => subscriber.complete(),
  }));
}
